import React, {useEffect, useMemo, useState} from 'react';
import moment from 'moment/moment';
import Translate from '../Translate/Translate';

const SECOND_IN_MS = 1000;

export default function NextAttemptCountdown(props: { countUntil: Date | moment.Moment, message: string, soonMessage?: string }) {
    const futureMs = useMemo<number>(() => +props.countUntil, [props.countUntil]);
    const [seconds, setSeconds] = useState<number>(
            Math.ceil((futureMs - Date.now()) / SECOND_IN_MS)
    );

    useEffect(() => {
        const interval = setInterval(() => {
            const seconds = Math.ceil((futureMs - Date.now()) / SECOND_IN_MS);
            setSeconds(seconds);
            if (seconds < 0) {
                clearInterval(interval);
            }
        }, 500);

        return () => clearInterval(interval);
    }, [futureMs]);

    return <Translate
            message={props.soonMessage && seconds < 1 ? props.soonMessage : props.message}
            choice={seconds}
            replace={{number: seconds}}
    />;
}
